import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ModuleCard = ({ module, courseSlug, onClick, isLocked = false }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (isLocked) return;
    if (onClick) {
      onClick(module);
    } else if (courseSlug && module?.slug) {
      navigate(`/course/${courseSlug}/module/${module.slug}`);
    }
  };

  const getStatusBadge = () => {
    if (isLocked) {
      return { text: 'Bloqueado', className: 'bg-muted text-muted-foreground' };
    }
    if (module?.status === 'available') {
      return { text: 'Disponível', className: 'bg-success text-success-foreground' };
    }
    if (module?.status === 'coming_soon') {
      return { text: 'Em Breve', className: 'bg-warning text-warning-foreground' };
    }
    return { text: 'Indisponível', className: 'bg-muted text-muted-foreground' };
  };

  const badge = getStatusBadge();

  return (
    <div
      className={`bg-card rounded-lg overflow-hidden shadow-tier-1 transition-all duration-300 group ${
        isLocked
          ? 'opacity-60 cursor-not-allowed'
          : 'hover:shadow-tier-2 cursor-pointer'
      }`}
      onClick={handleClick}
    >
      <div className="relative aspect-video overflow-hidden">
        <Image
          src={module?.cover || '/assets/images/no_image.png'}
          alt={module?.title}
          className={`w-full h-full object-cover transition-transform duration-300 ${
            isLocked ? '' : 'group-hover:scale-105'
          }`}
        />

        <div
          className={`absolute inset-0 transition-colors duration-300 ${
            isLocked ? 'bg-black/30' : 'bg-black/0 group-hover:bg-black/20'
          }`}
        ></div>

        <div
          className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${
            isLocked ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
          }`}
        >
          <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center backdrop-blur-sm">
            <Icon name={isLocked ? 'Lock' : 'Play'} size={20} className="text-primary ml-1" />
          </div>
        </div>

        <div className="absolute top-2 left-2">
          <span className={`px-2 py-1 text-xs font-medium rounded ${badge?.className}`}>
            {badge?.text}
          </span>
        </div>
      </div>

      <div className="p-4">
        <h3
          className={`font-heading font-semibold text-card-foreground mb-2 line-clamp-2 transition-colors ${
            isLocked ? '' : 'group-hover:text-primary'
          }`}
        >
          {module?.title}
        </h3>

        {module?.summary && (
          <p className="text-sm text-muted-foreground mb-4 line-clamp-2 font-caption">
            {module?.summary}
          </p>
        )}

        <div className="flex items-center justify-between text-xs text-muted-foreground font-caption">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-1">
              <Icon name="FileText" size={12} />
              <span>{module?.lessons?.length || 0} lições</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleCard;
